import { API, setAuthToken } from "../../../config/API.js";

export const getVisiMisiData = () => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/about/vismis`);
};

export const updVisiMisiData = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/about/vismis/edit", params);
};
